export default "__VITE_ASSET__D27k_dj6__"